import { RouteObject } from 'react-router';

export const privateRoutes: RouteObject[] = [
  // { path: Path.Home, element: <HomePage /> },
];


